import { useState } from "react";
import ModalWrapper from "../illustration-service/ServiceEditor/ModalWrapper/ModalWrapper";
import styles from "./gamesWrapper.module.scss";
import SnakeGames from "./snake";
import TicTacToe from "./ticTacToe";

const GamesWrapper = ({ close, task }) => {
	const [selectedGame, setSelectedGame] = useState(null); // snake, ticTacToe

	const isDown = () => {
		if (!task?.status) {
			return "processing is expected to begin";
		}

		if (task.status === "COMPLETED" || task.status === "ERROR") {
			return "Job is completed";
		} else {
			return `ready ${task.results.filter((item) => item.status === "COMPLETED").length} of task ${task.results.length}`;
		}
	};

	return (
		<ModalWrapper closeModal={selectedGame === null ? close : () => setSelectedGame(null)}>
			<div>
				<div className={styles.info}>{isDown()}</div>
				{selectedGame === null && (
					<div className={styles.btnWrapper}>
						<button className={styles.btn} onClick={() => setSelectedGame("snake")}>
							🐍
						</button>
						<button className={styles.btn} onClick={() => setSelectedGame("ticTacToe")}>
							❌⭕
						</button>
					</div>
				)}
				{selectedGame === "snake" && <SnakeGames />}
				{selectedGame === "ticTacToe" && <TicTacToe />}
			</div>
		</ModalWrapper>
	);
};

export default GamesWrapper;
